import React from 'react'
import './styles.scss'

export function Disclaimer(props) {
  return (
    <div className='box ta text disclaimer'>
      <p>
        Googlebewertungen sind ein entscheidender Faktor, ob ein Restaurant oder
        ein Geschäft betreten wird. Diese Serie widmet sich diesen goldenen
        Sternen und sucht die besten - und weniger guten - Unternehmen jeder
        Kategorie.
      </p>
      {/* {data && (
        <>
        <p style={{fontWeight: 'bold'}}>Lesen Sie weitere Google-Analysen</p>
        <ul>
          {data.filter(d => d.id != props.id).map(d => <li key={d.id}><a href={d.url}>{d.name}</a></li>)}
        </ul>
        </>
      )} */}
    </div>
  )
}

export default Disclaimer
